import { Translations } from '../types/Translations';

export const useTranslations = (): Translations => {
	if (typeof window === 'undefined' || !window._esfn?.translations) {
		throw new Error('Translations not available on window._esfn.translations');
	}

	return window._esfn.translations;
};
